import {
  BasePortalOutlet,
  CdkPortalOutlet,
  ComponentPortal,
  TemplatePortal,
} from '@angular/cdk/portal';
import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  EmbeddedViewRef,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'rt-notifications-container',
  template: ` <ng-template cdkPortalOutlet></ng-template> `,
  styleUrls: ['./notifications-container.component.less'],
  imports: [CdkPortalOutlet],
})
export class NotificationsContainerComponent extends BasePortalOutlet {
  private static LIMIT: number = 2;

  @ViewChild(CdkPortalOutlet, { static: true }) public portalOutlet: CdkPortalOutlet;

  private savedComponentRefs: Map<string, ComponentRef<any>> = new Map();

  private activeNotificationReferenceList: Array<ComponentRef<any>> = [];

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  public attachTemplatePortal<T>(portal: TemplatePortal<T>): EmbeddedViewRef<T> {
    return this.portalOutlet.attachTemplatePortal(portal);
  }

  public attachComponentPortal<T>(
    portal: ComponentPortal<T>,
    groupIdentifier?: string,
  ): ComponentRef<T> {
    const componentRef = this.portalOutlet.attachComponentPortal(portal);
    this.savedComponentRefs.set(groupIdentifier!, componentRef);
    this.activeNotificationReferenceList.push(componentRef);

    componentRef.onDestroy(() => {
      this.savedComponentRefs.delete(groupIdentifier!);
    });

    return componentRef;
  }

  public menageNotificationNumber() {
    if (this.activeNotificationReferenceList.length > NotificationsContainerComponent.LIMIT) {
      const [first, second, ...rest] = this.activeNotificationReferenceList;

      if (first.componentType.name === 'AutomatedActionsAssistantComponent') {
        second.hostView.destroy();
        this.activeNotificationReferenceList = [first, ...rest];
      } else {
        first.hostView.destroy();
        this.activeNotificationReferenceList = [second, ...rest];
      }
    }
  }

  public remove(groupIdentifier: string) {
    if (this.savedComponentRefs.get(groupIdentifier)) {
      this.savedComponentRefs.get(groupIdentifier)!.hostView.destroy();
      this.savedComponentRefs.delete(groupIdentifier);
    }
  }

  public refresh(): void {
    this.cdRef.detectChanges();
  }
}
